import homeRight from "./images/home-right.png";
import GiriBg from "./images/GiriBg.png";
import resume from "./resume/Girish-Resume-Front-end.pdf";

export default function HomePage() {
  return (
    <div className="flex justify-center">
      <div
        id="home"
        className="homeContainer flex w-full h-auto lg:min-h-screen justify-center items-center"
        style={{
          backgroundImage: `url(${GiriBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex w-4/5 h-auto lg:min-h-screen py-24">
          <div className="left-container w-full lg:w-3/5 flex flex-col justify-center lg:justify-start">
            <p className="flex items-center w-full text-4xl font-bold">
              HELLO
              <span className="inline-block h-[2px] bg-black w-2/3 ml-5"></span>
            </p>
            <span className="font-bold text-6xl my-5">I AM GIRISH KUMAR</span>
            <span className="font-bold text-2xl mb-8">FRONTEND DEVELOPER</span>
            <div className="buttonContainer flex flex-col lg:flex-row gap-5">
              <button className="rounded-lg px-10 py-3 bg-violet-600 text-white font-bold border-2 border-violet-600 hover:bg-white hover:text-black transition-all duration-300 shadow-lg shadow-violet-400 hover:shadow-none">
                {/* <a href="mailto:girishkumarsp70@gmail.com">
                HIRE ME
                </a> */}
                <a href="mailto:girishkumarsp70@gmail.com">
                  HIRE ME
                </a>
              </button>
              <button className="rounded-lg px-10 py-3 border-2 border-violet-600 font-bold hover:text-white hover:bg-violet-600 hover:shadow-lg hover:shadow-violet-400 transition-all duration-300">
                <a href={resume} download="Girish_Resume_Front_end.pdf">
                  GET CV
                </a>
              </button>
            </div>
          </div>
          <div className="right-container hidden lg:block max-w-md">
            <img src={homeRight} alt="avatarImg" />
          </div>
        </div>
      </div>
      <div id="about" className="mb-16"></div>
    </div>
  );
}
